import { z } from "zod";
import { optionalTrimmedString } from "./primitives";

export const themeSchema = z.enum(["light", "dark"]);
export const densitySchema = z.enum(["comfortable", "compact"]);

export const userPreferencesSchema = z.object({
  theme: themeSchema.optional(),
  density: densitySchema.optional(),
  lastActiveOrgId: optionalTrimmedString,
});

export type UserPreferencesPayload = z.infer<typeof userPreferencesSchema>;
